import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Oscar Marketplace",
  shortName: "Oscar",
  slug: "oscar-marketplace-insurance",
  seoTitle: "Oscar Marketplace TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have an Oscar Marketplace plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your ACA marketplace plan in Coral Springs, FL.",
  seoKeywords:
    "Oscar Marketplace TMS coverage, Oscar TMS therapy, Oscar ACA depression treatment Florida, Oscar Marketplace mental health benefits, Oscar SAINT TMS",
  planType: "Health Insurance Marketplace plan (ACA / Healthcare.gov)",
  planRegion: "Florida and select states",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits as an essential health benefit, including mental health services",
  planSpecificIntro:
    "Oscar Health offers individual and family health insurance plans through the Health Insurance Marketplace (Healthcare.gov). Oscar is known for its technology-driven approach to healthcare and member experience. These ACA-compliant plans include behavioral health benefits as one of the ten essential health benefits, which may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Because Oscar Marketplace plans come in different metal tiers, coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific plan tier, deductible, and network.",
  officialResourceUrl: "https://www.hioscar.com/",
  officialResourceLabel: "Oscar Marketplace plans",
};

export const OscarMarketplaceInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default OscarMarketplaceInsurance;
